import * as ngxMask from 'ngx-mask';

window['ngx-mask'] = ngxMask

export { ngxMask };